import { ProjectService } from './../common-theme/api/project.service';
import { Component, OnInit, Injector } from '@angular/core';
import { HomeBaseComponent } from './../common-theme/index';
import { Project, Reason } from './../common-theme/models/index';
import { ActivatedRoute } from '@angular/router';
import { OpenModalService } from './../common-theme/base-components/shared/modals/open-modal.service';
import { AgencyService } from '../common-theme/api/agency.service';
import { PropertyService } from '../common-theme/api/property.service';

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.scss']
})

export class HomeComponent extends HomeBaseComponent implements OnInit {
  public projects: Project[] = [];

  constructor(
    injector: Injector,
    agencyService: AgencyService,
    propertyService: PropertyService,
    openModalService: OpenModalService,
    route: ActivatedRoute,
    private projectService: ProjectService
  ) {
    super(
      injector,
      agencyService,
      route,
      propertyService,
      openModalService
    );

    this.projectService.getProject(119).then(project1 => {
      this.projects.push(project1)
      this.projectService.getProject(123).then(project2 => {
        this.projects.push(project2)
        this.projectService.getProject(36).then(project3 => {
          this.projects.push(project3)
          this.projectService.getProject(116).then(project4 => this.projects.push(project4));
        });
      });
    });
   }

  ngOnInit(): void {
    super.ngOnInit();

    this.route.data.forEach((data: { reasons: Reason[] }) => {
      this.reasons = data.reasons;
    });
  }
}



// WEBPACK FOOTER //
// ./src/app/home/home.component.ts